import { Icon } from "antd";
import React from "react";
import ActivityCard from "./activityCard";
export function ActivityCardCol({ data }) {
    
    return <>
        <ActivityCard cardStyle={{
            className: "dashboardCard",
            title: <><img src="https://static-fastly.hackerearth.com/static/hackerearth/images/logo/HE_identity.png" style={{
                width: 20,
                height: 20
            }}></img> HackerEarth</>,
            bordered: true,
            bodyStyle: {
                background: "rgb(127, 148, 230)"
            },
            headStyle: {
                background: "rgb(165, 179, 232)"
            },
            actions: null
        }} statisticColData={[["Students", data.hackerEarth ? data.hackerEarth : 'NA', <Icon type="user" />, "/100"], ["Problems Solved", "NA", <Icon type="radar-chart" />, "/100"]]} />

        <ActivityCard cardStyle={{
            className: "dashboardCard",
            title: <><img src="https://www.hackerrank.com/wp-content/uploads/2018/07/hackerrank-favicon.png" style={{
                width: 20,
                height: 20
            }}></img> HackerRank</>,
            bordered: true,
            bodyStyle: {
                background: "#87b998"
            },
            headStyle: {
                background: "#89eaac"
            },
            actions: null
        }} statisticColData={[["Students", data.hackerRank ? data.hackerRank : 'NA', <Icon type="user" />, "/100"], ["Problems Solved", "NA", <Icon type="radar-chart" />, "/100"]]} />

        <ActivityCard cardStyle={{
            className: "dashboardCard",
            title: <><img src="https://s3.amazonaws.com/codechef_shared/misc/favicon.ico" style={{
                width: 20,
                height: 20
            }}></img> CodeChef</>,
            bordered: true,
            bodyStyle: {
                background: "rgb(206, 146, 96)"
            },
            headStyle: {
                background: "rgb(173, 139, 113)"
            },
            actions: null
        }} statisticColData={[["Students", data.codeChef ? data.codeChef : 'NA', <Icon type="user" />, "/100"], ["Problems Solved",  "NA", <Icon type="radar-chart" />, "/100"]]} />

        <ActivityCard cardStyle={{
            className: "dashboardCard",
            title: <><img src="https://www.geeksforgeeks.org/favicon.ico" style={{
                width: 20,
                height: 20
            }}></img> GeeksForGeeks</>,
            bordered: true,
            bodyStyle: {
                background: "rgb(134, 222, 177)"
            },
            headStyle: {
                background: "#45d089"
            },
            actions: null
        }} statisticColData={[["Students", data.geeksForGeeks ? data.geeksForGeeks : 'NA', <Icon type="user" />, "/100"], ["Problems Solved", "NA", <Icon type="radar-chart" />, "/100"]]} />
    </>;
}
